import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CogRegular from './cog-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CogRegular {...validProps} />;
}

SvgComponent.iconName = 'cogRegular';

export const CogRegularIcon = svgIconWrapper(SvgComponent);
